import { WebworkerType } from "./webworker-type.ts";

const callbackMethodsById = new Map();
const callbackIdsByMethod = new Map();

export const initWebworker = <T extends WebworkerType>(handlers : T) => {
  
    addEventListener("message", async (event) => {
        //console.log("worker", event.data)
        switch(event.data.type) {
            case "WebworkerMethodCall":
                let response = await handlers[event.data.methodName as keyof T](...deserializeParams(event.data.params));

                if(response instanceof Function) {
                    const savedResponse = response;
                    const callbackId = registerCallback(() => {
                        savedResponse();
                        callbackMethodsById.delete(callbackId);
                    })

                    response = {
                        type: "WebworkerCallbackReference",
                        callbackId: callbackId
                    }
                }

                postMessage({ type: "WebworkerMethodResponse", resolver: event.data.resolverId, response } );
                
                break;

            case "WebworkerCallback":
                callbackMethodsById.get(event.data.callbackId)?.(event.data.params);

                break;
        }
    });

    postMessage({ type: "WebworkerReady", methods: Object.keys(handlers) });
}

const registerCallback = (callBack : (...param : any[]) => void) => {
    const callbackId = crypto.randomUUID();
    callbackMethodsById.set(callbackId, callBack);
    return callbackId;
}

export const unregisterCallbackByMethod = (callbackMethod : (...params : any[]) => any) => {
    const callbackId = callbackIdsByMethod.get(callbackMethod);
    if(callbackId) {
        postMessage({ type: "UnregisterCallback", callbackId });
        callbackIdsByMethod.delete(callbackMethod);
    }
}

const deserializeParams = (params : any[]) => params.map(param => {
    if(param.type === "WebworkerCallbackReference") {
        const method = (...params : any) => postMessage({ type: "WebworkerCallback", callbackId: param.callbackId, params } );
        callbackIdsByMethod.set(method, param.callbackId);
        return method;
    }

    return param;
})